import styles from "./routeJourney.module.css"
import { Icon } from "../../../../../features/ui"

type Props = {
    sortedAddresses: string[]
}

export const RouteJourney = (props: Props) => {
    const { sortedAddresses } = props
    
    return (
        <div className={styles.container}>
            {sortedAddresses.map((address, index) => (
                <div key={index} className={styles.stopItem}>
                    <Icon icon="geo-alt" />
                    <span className={styles.stopLabel}>
                        {index === 0 
                            ? "Salida" 
                            : index === sortedAddresses.length - 1 
                                ? "Llegada" 
                                : `Parada ${index}`}:
                    </span>
                    <span className={styles.address}>{address}</span>
                </div>
            ))}
        </div>
    )
}
